/* eslint-disable camelcase */
import { get, post, remove } from "./base";
import store from "../store";
import * as actions from "../store/actions/platforms";
import url from "./url";
import queries from "./queries";

const { dispatch } = store;

// === Audience compliance ===

async function getAudienceCompliance({ id, type, headers = {} } = {}) {
  try {
    const query = url(queries.audienceCompliance({ id, type }));
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

// === End Audience compliance ===

// === FB ===

async function fbCheckAuthToken({ headers = {} } = {}) {
  try {
    const query = url(queries.platformFBCheckAuth);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function fbSetAccessToken({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformFBAccessToken);
    // dispatch(actions.getPlans());
    const response = await post(query, data, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
    // return dispatch(actions.getPlansFailed(errorData || error));
  }
}

async function fbPush({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformFBPush);
    dispatch(actions.adformPush());
    const response = await post(query, data, headers);
    dispatch(actions.adformPushSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.adformPushFailed(err));
  }
}

async function fbLogout({ headers = {} } = {}) {
  try {
    const query = url(queries.platformFBLogout);
    // dispatch(actions.getPlans());
    const response = await remove(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function fbGetAdAccounts({ headers = {} } = {}) {
  try {
    const query = url(queries.platformFBAdAccounts);
    const response = await get(query, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function fbGetCampaigns({ adAccountId, headers = {} } = {}) {
  try {
    const query = url(queries.platformFBCampaigns(adAccountId));
    const response = await get(query, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function fbGetAdSets({ campaignId, headers = {} } = {}) {
  try {
    const query = url(queries.platformFBAdSets(campaignId));
    const response = await get(query, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

// === End FB ===

// === Google ===

async function googleDownload({
  audienceType,
  audienceValue,
  clientId,
  headers = {}
} = {}) {
  try {
    const query = url(
      `${queries.platformGoogleDownload}?${audienceType}_id=${audienceValue}&client_id=${clientId}`
    );
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

// === End Google ===

// === AdForm ===

async function adformGetCampaigns({ headers = {} } = {}) {
  try {
    const query = url(queries.platformAdformCampaigns);
    const response = await get(query, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function adformGetLineitems({ campaignId, headers = {} } = {}) {
  try {
    const query = url(queries.platformAdformLineitems(campaignId));
    const response = await get(query, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function adformCheckAuthToken({ headers = {} } = {}) {
  try {
    const query = url(queries.platformAdformCheckAuth);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function adformGetAuthorizeLink({ headers = {} } = {}) {
  try {
    const query = url(queries.platformAdformAuthorize);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function adformSetAccessToken({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformAdformAccessToken);
    // dispatch(actions.getPlans());
    const response = await post(query, data, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
    // return dispatch(actions.getPlansFailed(errorData || error));
  }
}

async function adformPush({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformAdformPush);
    dispatch(actions.adformPush());
    const response = await post(query, data, headers);
    dispatch(actions.adformPushSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.adformPushFailed(err));
  }
}

async function adformLogout({ headers = {} } = {}) {
  try {
    const query = url(queries.platformAdformLogout);
    // dispatch(actions.getPlans());
    const response = await remove(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

// === End AdForm ===

// === Google Ads ===

async function googleAdsCheckAuthToken({ headers = {} } = {}) {
  try {
    const query = url(queries.platformGoogleAdsCheckAuth);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function googleAdsSetRefreshToken({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformGoogleAdsRefreshToken);
    // dispatch(actions.getPlans());
    const response = await post(query, data, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
    // return dispatch(actions.getPlansFailed(errorData || error));
  }
}

async function googleAdsPush({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformGoogleAdsPush);
    dispatch(actions.googleAdsPush());
    const response = await post(query, data, headers);
    dispatch(actions.googleAdsPushSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.googleAdsPushFailed(err));
  }
}

async function googleAdsLogout({ headers = {} } = {}) {
  try {
    const query = url(queries.platformGoogleAdsLogout);
    // dispatch(actions.getPlans());
    const response = await remove(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

// async function googleAdsGetCustomers({ data = {}, headers = {} } = {}) {
//   try {
//     const query = url(queries.platformGoogleAdsCustomers);
//     const response = await get(query, data, headers);
//     return response;
//   } catch (error) {
//     const errorData = error.response && error.response.data;
//     return errorData || error;
//   }
// }

async function googleAdsGetCampaigns({
  customerId,
  data = {},
  headers = {}
} = {}) {
  try {
    const query = url(queries.platformGoogleAdsCampaigns(customerId));
    const response = await get(query, data, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

// === End Google Ads ===

// === Ttd ===

async function TtdPush({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformTtdPush);
    dispatch(actions.ttdPush());
    const response = await post(query, data, headers);
    dispatch(actions.ttdPushSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.ttdPushFailed(err));
  }
}

// === End Ttd ===

// === Snapchat ===

async function snapchatGetAuthorizeLink({ headers = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatAuthorize);
    const response = await get(query, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function snapchatCheckAuthToken({ headers = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatCheckAuth);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function snapchatSetAccessToken({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatRefreshToken);
    const response = await post(query, data, headers);
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function snapchatPush({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatPush);
    dispatch(actions.googleAdsPush());
    const response = await post(query, data, headers);
    dispatch(actions.googleAdsPushSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.googleAdsPushFailed(err));
  }
}

async function snapchatLogout({ headers = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatLogout);
    const response = await remove(query, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function snapchatGetOrganizations({ headers = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatOrganizations);
    const response = await get(query, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function snapchatGetAdAccounts({
  organizationId,
  data = {},
  headers = {}
} = {}) {
  try {
    const query = url(queries.platformSnapchatAdAccounts(organizationId));
    const response = await get(query, data, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function snapchatGetCampaigns({
  adAccountId,
  data = {},
  headers = {}
} = {}) {
  try {
    const query = url(queries.platformSnapchatCampaigns(adAccountId));
    const response = await get(query, data, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function snapchatGetAdSets({ campaignId, data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.platformSnapchatAdSets(campaignId));
    const response = await get(query, data, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

// === End Snapchat ===

// === Xandr ===

async function xandrCheckAuthToken({ headers = {} } = {}) {
  try {
    const query = url(queries.platformXandrCheckAuth);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function xandrLogout({ headers = {} } = {}) {
  try {
    const query = url(queries.platformXandrLogout);
    const response = await remove(query, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function xandrAuth({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformauthXandr);
    await post(query, data, headers);
    return true;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function xandrGetAdvertisers({ headers = {} } = {}) {
  try {
    const query = url(queries.platformXandrAdvertisers);
    const response = await get(query, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function xandrGetLineItems({ advertiser_id, headers = {} } = {}) {
  try {
    const query = url(
      `${queries.platformXandrLineItems}?advertiser_id=${advertiser_id}`
    );
    const response = await get(query, headers);
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return errorData || error;
  }
}

async function xandrPush({ headers = {}, data = {} } = {}) {
  try {
    const query = url(queries.platformXandrPush);
    dispatch(actions.xandrPush());
    const response = await post(query, data, headers);
    dispatch(actions.xandrPushSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.xandrPushFailed(err));
  }
}

async function xandrDownload({
  audienceType,
  audienceValue,
  clientId,
  headers = {}
} = {}) {
  try {
    const query = url(
      `${queries.platformXandrDownload}?${audienceType}_id=${audienceValue}&client_id=${clientId}`
    );
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    // const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return error;
  }
}

async function xandrDownloadZIP({
  audienceType,
  audienceValue,
  clientId,
  headers = {}
}) {
  try {
    const query = url(
      `${queries.platformXandrDownloadZIP}?${audienceType}_id=${audienceValue}&client_id=${clientId}`
    );
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    // const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return error;
  }
}

// === End Xandr ===

// === SmartClip ===
async function smartClipDownloadCheckAbility({ headers = {} } = {}) {
  try {
    const query = url(`${queries.platformSmartClipCheckAbility}`);
    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    // TODO: Implement error hadling
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function llCoordinatesDownload({
  audienceType,
  audienceValue,
  clientId,
  headers = {}
}) {
  try {
    const query = url(
      `${queries.platformLlCoordinatesDownload}?${audienceType}_id=${audienceValue}&client_id=${clientId}`
    );
    dispatch(actions.xandrPush());

    const response = await get(query, headers);
    dispatch(actions.xandrPushSuccess());

    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function postalCodesDownload({
  audienceType,
  audienceValue,
  clientId,
  headers = {}
} = {}) {
  try {
    const query = url(
      `${queries.platformPostalCodesDownload}?${audienceType}_id=${audienceValue}&client_id=${clientId}`
    );
    dispatch(actions.xandrPush());

    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    dispatch(actions.xandrPushSuccess());

    return response;
  } catch (error) {
    dispatch(actions.xandrPushFailed());

    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

async function smartClipDownload({
  audienceType,
  audienceValue,
  clientId,
  headers = {}
} = {}) {
  try {
    const query = url(
      `${queries.platformSmartClipDownload}?${audienceType}_id=${audienceValue}&client_id=${clientId}`
    );
    dispatch(actions.xandrPush());

    // dispatch(actions.getPlans());
    const response = await get(query, headers);
    // dispatch(actions.getPlansSuccess(response));
    dispatch(actions.xandrPushSuccess());

    return response;
  } catch (error) {
    // TODO: Implement error hadling
    dispatch(actions.xandrPushFailed());

    const errorData = error.response && error.response.data;
    // return dispatch(actions.getPlansFailed(errorData || error));
    return errorData || error;
  }
}

// === End SmartClip ===

export default class platforms {
  static fb = {
    isAuthorized: fbCheckAuthToken,
    setAccessToken: fbSetAccessToken,
    push: fbPush,
    logout: fbLogout,
    getAdAccounts: fbGetAdAccounts,
    getCampaigns: fbGetCampaigns,
    getAdSets: fbGetAdSets
  };

  static googleAds = {
    isAuthorized: googleAdsCheckAuthToken,
    setRefreshToken: googleAdsSetRefreshToken,
    push: googleAdsPush,
    logout: googleAdsLogout,
    // getCustomers: googleAdsGetCustomers,
    getCampaigns: googleAdsGetCampaigns
  };

  static google = {
    download: googleDownload
  };

  static adform = {
    getCampaigns: adformGetCampaigns,
    getLineitems: adformGetLineitems,
    isAuthorized: adformCheckAuthToken,
    getAuthorizeLink: adformGetAuthorizeLink,
    setAccessToken: adformSetAccessToken,
    push: adformPush,
    logout: adformLogout
  };

  static Ttd = {
    push: TtdPush
  };

  static snapchat = {
    isAuthorized: snapchatCheckAuthToken,
    setAccessToken: snapchatSetAccessToken,
    push: snapchatPush,
    logout: snapchatLogout,
    getAuthorizeLink: snapchatGetAuthorizeLink,
    getOrganizations: snapchatGetOrganizations,
    getAdAccounts: snapchatGetAdAccounts,
    getCampaigns: snapchatGetCampaigns,
    getAdSets: snapchatGetAdSets
  };

  static xandr = {
    isAuthorized: xandrCheckAuthToken,
    logout: xandrLogout,
    auth: xandrAuth,
    push: xandrPush,
    getAdvertisers: xandrGetAdvertisers,
    getLineItems: xandrGetLineItems,
    download: xandrDownload,
    downloadZIP: xandrDownloadZIP
  };

  static smartClip = {
    downloadCheckAbility: smartClipDownloadCheckAbility,
    download: smartClipDownload
  };

  static postalCodes = {
    download: postalCodesDownload
  };

  static llCoordinates = {
    download: llCoordinatesDownload
  };

  static additional = {
    getAudienceCompliance
  };
}
